/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */
import MScolumn2D from './mscolumn2d';
import ColumnDataset from '../_internal/datasets/column';
import Columngroup from '../_internal/datasets/groups/column.multiseries';
import { pluckNumber } from '../_internal/lib/lib';
import { scrollTo } from '../_internal/misc/scroll-apis';
let mathFloor = Math.floor,
  UNDEF;
/**
 * Sets xAxis scale visible region
 */
function _setAxisScale () {
  var iapi = this,
    config = iapi.config,
    xAxis = iapi.getChildren('xAxis')[0],
    catCount = xAxis.getTicksLen(),
    jsonData = iapi.getFromEnv('dataSource'),
    chartAttr = jsonData.chart,
    chartWidth = config.width,
    xAxisMin,
    xAxisMax,
    minVisiblePlots = 2, // at the least a scroll chart must show 2 plots
    numOfColumnSeries = 0,
    totalNumPoint,
    visibleRange,
    xAxisLimit,
    scrollToEnd = config.scrollToEnd,
    // number of columns to be drawn.
    numVisiblePlot = pluckNumber(chartAttr.numvisibleplot,
      mathFloor(chartWidth / iapi.avgScrollPointWidth));

  iapi.iterateComponents((child) => {
    if ((child.getType && child.getType() === 'dataset')) {
      if (child.getName && child.getName() === 'column') {
        !child.getState('removed') && (numOfColumnSeries++);
      }
    }
  });

  if (iapi.config.isstacked) {
    numOfColumnSeries = 1;
  }

  numOfColumnSeries = numOfColumnSeries || 1;

  totalNumPoint = catCount * numOfColumnSeries;

  ({maxValue: xAxisMax, minValue: xAxisMin} = xAxis.getVisibleConfig());

  if (numVisiblePlot >= minVisiblePlots && numVisiblePlot < totalNumPoint) {
    visibleRange = numVisiblePlot / numOfColumnSeries;
    xAxis.setScrollType('always');
    if (scrollToEnd) {
      xAxisMin = xAxisMax - visibleRange;
    } else {
      xAxisMax = xAxisMin + visibleRange;
    }

    xAxis.setVisibleConfig(xAxisMin, xAxisMax);
  } else {
    xAxisLimit = xAxis.getLimit();
    // when there is enough space for plots then chart must inform to axis since axis maintains
    // the visible configuration during the resize
    xAxis.setVisibleConfig(xAxisLimit.min, xAxisLimit.max);
    xAxis.setScrollType('none');
  }
}

/**
 * Reset view port
 */
function _resetViewPortConfig () {
  var iapi = this;

  iapi.config.viewPortConfig = {
    scaleX: 1,
    scaleY: 1,
    x: 0,
    y: 0
  };
}

/**
 * function to create component and configure and also configure the chart
 * It creates components which are depend on data and configure them and also configure chart
 * It calls helper function namely, configure
 * @param  {Object} dataObj contains json data of the chart
 */
function _configurer () {
  var chart = this,
    jsonData = chart.getFromEnv('dataSource'),
    chartAttr = jsonData.chart,
    chartConfig;
  chartConfig = chart.config;
  chartConfig.scrollToEnd = pluckNumber(chartAttr.scrolltoend, 0);
  chartConfig.lastScrollPosition = UNDEF;
}
/**
 * Creates ScrollColumn2D class
 */
class ScrollColumn2D extends MScolumn2D {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'ScrollColumn2D';
  }

  /**
   * Function to state if inputOptions are to be used for this charts
   * @return {Array} value
   */
  static includeInputOptions () {
    return ['SwipeGesture'];
  }

  /**
   * Constructor fn of ScrollColumn2D class
   */
  constructor () {
    super();
    this.tooltipConstraint = 'plot';
    this.canvasborderthickness = 1;
    this.avgScrollPointWidth = 40;
    this.hasScroll = true;
    this.defaultPlotShadow = 1;
    this.binSize = 0;
    this.eiMethods.scrollTo = scrollTo;
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'ScrollColumn2D';
  }
  /**
   * Sets default configuration
   * @memberof ScrollColumn2D
   */
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.defaultDatasetType = 'column';
    config.showzeroplaneontop = 1;
    config.friendlyName = 'Scrollable Multi-series Column Chart';
  }

  /**
   * function to create component and configure and also configure the chart
   * It creates components which are depend on data and configure them and also configure chart
   * It calls helper function namely, configure
   * @param  {Object} dataObj contains json data of the chart
   */
  configureAttributes (dataObj) {
    super.configureAttributes(dataObj);
    _configurer.call(this, dataObj);
  }

  /**
   * Sets xAxis scale visible region
   */
  _setAxisScale () {
    _setAxisScale.call(this);
  }
  /**
   * Parse the chart attributes and store in chart's config
   * @param {Object} dataObj User input json
   */
  parseChartAttr (dataObj) {
    super.parseChartAttr(dataObj);
    this.config.drawTrendRegion = 0;
  }

  /**
   * Reset view port
   */
  _resetViewPortConfig () {
    _resetViewPortConfig.call(this);
  }
  /**
   * Returns dataset class
   * @return {class} returns ColumnDataset class
   */
  getDSdef () {
    return ColumnDataset;
  }
  /**
   * Returns dataset group class
   * @return {class} returns Columngroup class
   */
  getDSGroupdef () {
    return Columngroup;
  }
}
export default ScrollColumn2D;
export { _setAxisScale, _resetViewPortConfig, _configurer as configurer };
